export const LOAD_DOCUMENT_TASKS_SUCCEEDED = 'LOAD_DOCUMENT_TASKS_SUCCEEDED';
export const LOAD_DOCUMENT_TASKS_STARTED = 'LOAD_DOCUMENT_TASKS_STARTED';
export const LOAD_DOCUMENT_TASKS_FAILED = 'LOAD_DOCUMENT_TASKS_FAILED';
export const LOAD_TASK_OPTIONS_SUCCEEDED = 'LOAD_TASK_OPTIONS_SUCCEEDED';
export const LOAD_CLIENT_CATEGORIES_SUCCEEDED = 'LOAD_CLIENT_CATEGORIES_SUCCEEDED';
export const LOAD_TASK_TYPES_SUCCEEDED = 'LOAD_TASK_TYPES_SUCCEEDED';
export const LOAD_TASK_RESPONSIBLES_SUCCEEDED = 'LOAD_TASK_RESPONSIBLES_SUCCEEDED';
export const LOAD_TASK_STATES_SUCCEEDED = 'LOAD_TASK_STATES_SUCCEEDED';
export const LOAD_TASK_STATUSES_SUCCEEDED = 'LOAD_TASK_STATUSES_SUCCEEDED';
export const LOAD_DASHBOARD_TASKS_STARTED = 'LOAD_DASHBOARD_TASKS_STARTED';
export const LOAD_DASHBOARD_TASKS_SUCCEEDED = 'LOAD_DASHBOARD_TASKS_SUCCEEDED';
export const LOAD_DASHBOARD_TASKS_FAILED = 'LOAD_DASHBOARD_TASKS_FAILED';
export const LOAD_TASK_OPTIONS_FAILED = 'LOAD_TASK_OPTIONS_FAILED';
export const LOAD_CLIENT_CATEGORIES_FAILED = 'LOAD_CLIENT_CATEGORIES_FAILED';
export const LOAD_TASK_TYPES_FAILED = 'LOAD_TASK_TYPES_FAILED';
export const LOAD_TASK_RESPONSIBLES_FAILED = 'LOAD_TASK_RESPONSIBLES_FAILED';
export const LOAD_TASK_STATES_FAILED = 'LOAD_TASK_STATES_FAILED';
export const LOAD_TASK_STATUSES_FAILED = 'LOAD_TASK_STATUSES_FAILED';
export const LOAD_TASKS_CONFIG_SUCCEEDED = 'LOAD_TASKS_CONFIG_SUCCEEDED';
export const LOAD_TASKS_CONFIG_FAILED = 'LOAD_TASKS_CONFIG_FAILED';
export const LOAD_TASKS_RESPONSIBLES_SUCCEEDED = 'LOAD_TASKS_RESPONSIBLES_SUCCEEDED';
export const LOAD_TASKS_RESPONSIBLES_FAILED = 'LOAD_TASKS_RESPONSIBLES_FAILED';
export const PAUSE_TASK_STARTED = 'PAUSE_TASK_STARTED';
export const PAUSE_TASK_SUCCEEDED = 'PAUSE_TASK_SUCCEEDED';
export const PAUSE_TASK_FAILED = 'PAUSE_TASK_FAILED';
export const START_TASK_STARTED = 'START_TASK_STARTED';
export const START_TASK_SUCCEEDED = 'START_TASK_SUCCEEDED';
export const START_TASK_FAILED = 'START_TASK_FAILED';
export const RESET_TASKS = 'RESET_TASKS';
export const UPDATE_TASK_STARTED = 'UPDATE_TASK_STARTED';
export const UPDATE_TASK_SUCCEEDED = 'UPDATE_TASK_SUCCEEDED';
export const UPDATE_TASK_FAILED = 'UPDATE_TASK_FAILED';
export const UPDATE_TASK_PRIORITY_STARTED = 'UPDATE_TASK_PRIORITY_STARTED';
export const UPDATE_TASK_PRIORITY_SUCCEEDED = 'UPDATE_TASK_PRIORITY_SUCCEEDED';
export const UPDATE_TASK_PRIORITY_FAILED = 'UPDATE_TASK_PRIORITY_FAILED';
